<script>
  import { onMount } from 'svelte';

  const STORAGE_KEY = 'forum-industry.cookie-consent';

  let visible = false;

  onMount(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) !== 'accepted') {
        visible = true;
      }
    } catch {
      visible = true;
    }
  });

  function accept() {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {}
    visible = false;
  }
</script>

{#if visible}
  <div class="cookie-banner" role="dialog" aria-live="polite" aria-label="Уведомление о файлах cookie">
    <p class="cookie-banner__text">
      Мы используем cookie для работы сайта и аналитики. Продолжая пользоваться сайтом, вы соглашаетесь с
      <a href="/privacy">Политикой конфиденциальности</a>
      и
      <a href="/agreement">Пользовательским соглашением</a>.
    </p>
    <button class="cookie-banner__btn" type="button" on:click={accept}><span>Принять</span></button>
  </div>
{/if}

<style>
  .cookie-banner {
    position: fixed;
    left: 16px;
    right: 16px;
    bottom: 16px;
    z-index: 60;
    max-width: 720px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    border: 1px solid rgba(231, 185, 98, 0.4);
    border-radius: 12px;
    background: #0b0b0b;
    color: #ffffff;
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.45);
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 20px;
    box-sizing: border-box;
  }

  .cookie-banner__text {
    flex: 1 1 240px;
    margin: 0;
  }

  .cookie-banner__text a {
    color: #e7b962;
    text-decoration: underline;
  }

  .cookie-banner__text a:hover,
  .cookie-banner__text a:focus-visible {
    color: #ffffff;
  }

  .cookie-banner__btn {
    flex: 0 0 auto;
    padding: 10px 20px;
    border: 0;
    border-radius: 6px;
    background: #e7b962;
    color: #000000;
    font-family: inherit;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    text-transform: uppercase;
    cursor: pointer;
    transition: background-color 180ms ease;
  }

  .cookie-banner__btn:hover,
  .cookie-banner__btn:focus-visible {
    background: #ffa800;
  }

  @media (max-width: 767px) {
    .cookie-banner {
      left: 12px;
      right: 12px;
      bottom: 12px;
      padding: 14px 16px;
    }

    .cookie-banner__btn {
      flex: 1 1 100%;
    }
  }
</style>
